import React, { useEffect } from 'react'
import ErrorModal from '../../ErrorModal'
import FormlessInterstitialWrapper from '../../FormlessInterstitial'
import { AttributionDetails } from '../types'
import { AppFormEventParams } from '../../../services/events-service'
import { Application } from '../../../Mappers/ApplicationFormMapper'
import { LenderDetails } from '../ApplicationFormContext'
import withDetectRefresh, { InjectedJourneyProps } from '../../HOC/withDetectRefresh'

export type FormlessJourneyBaseProps = {
  experimentName: string
  attribution: AttributionDetails
  submissionResponse?: Record<string, any>
  isPreapproved: boolean
  eventsServiceUrl: string
  appFormEventParams?: AppFormEventParams
  mappedApplication?: Application
  lenderDetails?: LenderDetails
}

export type FormlessJourneyProps = 
  FormlessJourneyBaseProps & 
  InjectedJourneyProps


const FormlessJourney = ({
  experimentName,
  attribution,
  isPreapproved,
  // injected from HOC
  apiError,
  redirectUrl,
  closeError
}: FormlessJourneyProps): JSX.Element => {
  useEffect(() => {
    if (redirectUrl) {
      const timer = setTimeout(() => {
        window.location.replace(redirectUrl.toString())
      }, 5000)

      return () => clearTimeout(timer)
    }
  }, [redirectUrl])

  return (
    <>
      {apiError && (
        <ErrorModal
          titleText="Sorry"
          ctaText="Please try again"
          onClick={closeError}
        >
          There was a problem submitting your application
        </ErrorModal>
      )}
      {!apiError && attribution && (
        <FormlessInterstitialWrapper
          source={attribution.source}
          experimentName={experimentName}
          isPreapproved={isPreapproved}
        />
      )}
    </>
  )
}

export default withDetectRefresh(FormlessJourney)
